import React from "react";

const InstagramOutlinedIcon: React.FC = () => (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00033 18.3334H13.0003C17.167 18.3334 18.8337 16.6667 18.8337 12.5001V7.50008C18.8337 3.33341 17.167 1.66675 13.0003 1.66675H8.00033C3.83366 1.66675 2.16699 3.33341 2.16699 7.50008V12.5001C2.16699 16.6667 3.83366 18.3334 8.00033 18.3334Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4997 12.9166C12.1105 12.9166 13.4163 11.6107 13.4163 9.99992C13.4163 8.38909 12.1105 7.08325 10.4997 7.08325C8.88884 7.08325 7.58301 8.38909 7.58301 9.99992C7.58301 11.6107 8.88884 12.9166 10.4997 12.9166Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1971 5.83341H15.2067"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

export default InstagramOutlinedIcon;
